// extracted by mini-css-extract-plugin
export var billingAddress = "_yc-g";
export var contactInfo = "_yc-d";
export var customerInfoContainer = "_yc-c";
export var customerInfoContainerMobile = "_yc-h";
export var customerInfoRow = "_yc-a";
export var customerInfoSection = "_yc-b";
export var fullWidthDividerMobile = "_yc-i";
export var imageContainer = "_yc-1";
export var paymentMethod = "_yc-e";
export var priceText = "_yc-6";
export var priceTextMobile = "_yc-7";
export var product = "_yc-0";
export var productImage = "_yc-2";
export var productInfo = "_yc-4";
export var productMobile = "_yc-9";
export var productTitle = "_yc-8";
export var quantityBadge = "_yc-3";
export var quantityText = "_yc-5";
export var shippingAddress = "_yc-f";